import { cn } from '@/lib/utils'
import { Link } from 'react-router-dom'
import { IHeaderMenu } from './header-user'

export default function MenuHeaderDesktop({ menu }: { menu: IHeaderMenu }) {
  return (
    <nav className="items-center space-x-8 hidden lg:flex">
      {menu.map((item) => (
        <Link
          key={item.name}
          to={item.href}
          className={cn(
            'text-sm relative font-semibold text-[#9CA3AF] hover:text-[#000000]',
            {
              'text-[#000000]': item.isActive,
            }
          )}
        >
          {item.name}
          {item.isActive && (
            <span className="w-full h-[3px] top-[40px] block absolute bottom-0 left-0 bg-destructive" />
          )}
        </Link>
      ))}
    </nav>
  )
}
